"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrderV2 = void 0;
// https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language
var SortOrderV2;
(function (SortOrderV2) {
    SortOrderV2["ASC"] = "ASC";
    SortOrderV2["DESC"] = "DESC";
})(SortOrderV2 = exports.SortOrderV2 || (exports.SortOrderV2 = {}));
//# sourceMappingURL=QueryV2.js.map